module.exports = __webpack_public_path__ + "img/duration.e1310208.svg";